import * as React from "react";
import { Grid, Select, MenuItem, Button, Box, InputAdornment, IconButton, OutlinedInput } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect } from "react";

type PartitionSearchState = {
    searchBy?: number;
    searchText: string;
};

type PartitionSearchProps = {
    handleSearch: (searchBy: number, searchText: string) => void;
};

function PartitionSearch(props: PartitionSearchProps) {
    const [searchDetails, setSearchDetails] = React.useState<PartitionSearchState>({ searchBy: 1, searchText: "" });

    useEffect(() => {
        var search = JSON.parse(localStorage.getItem("searchDetails") ?? JSON.stringify({ searchBy: 1, searchText: "" }));
        setSearchDetails(search);
        props.handleSearch(search.searchBy || 0, search.searchText);
    }, []);

    // Remove search history for page refresh
    useEffect(() => {
        const handleBeforeUnload = (e: any) => {
            localStorage.removeItem("searchDetails");
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);


    const handleKeyPress = (e: any) => {
        if (e.key === "Enter") {
            handleSearch();
        }
    };

    const handleSearchDetailsChange = (params: any) => {
        var x = { ...params };
        setSearchDetails(x);

        localStorage.setItem("searchDetails", JSON.stringify(x));
    };

    const handleSearch = () => {
        props.handleSearch(searchDetails.searchBy || 0, searchDetails.searchText);
    };

    return (
        <Box mb={2}>
            <Grid container spacing={2} style={{ minWidth: "100px" }}>
                <Grid item xs={5} sm={2}>
                    <Select
                        size="small"
                        id="partitionsearch-searchby"
                        value={searchDetails.searchBy}
                        fullWidth
                        onChange={(x) =>
                            handleSearchDetailsChange({
                                searchBy: x.target.value,
                                searchText: searchDetails.searchText,
                            })
                        }
                    >
                        <MenuItem value={1}>Partition Name</MenuItem>
                        <MenuItem value={2}>Partition Reference</MenuItem>
                    </Select>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <OutlinedInput
                        size="small"
                        id="partitionsearch-searchtext"
                        fullWidth
                        value={searchDetails.searchText}
                        onChange={(x) =>
                            handleSearchDetailsChange({ searchBy: searchDetails.searchBy, searchText: x.target.value })
                        }
                        onKeyPress={handleKeyPress}
                        inputProps={{ maxLength: 50 }}
                        endAdornment={
                            searchDetails.searchText && (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={(e) => {
                                            handleSearchDetailsChange({ searchBy: searchDetails.searchBy, searchText: "" });
                                        }}
                                        size="medium"
                                    >
                                        <ClearIcon></ClearIcon>
                                    </IconButton>
                                </InputAdornment>
                            )
                        }
                    />
                </Grid>
                <Grid container item xs={4} sm={2}>
                    <Button id="partitionsearch-go" variant="contained" color="primary" onClick={(x) => handleSearch()}>
                        <SearchIcon />
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
}

export default PartitionSearch;
